export default "__VITE_ASSET__cdcc966e__"